<button (click)="handleClick()" class="flex flex-row items-center gap-[8px]">
  <mat-icon>cloud_download</mat-icon>
  <span>Export</span>
</button>